export const postData = [
  {
    id: 100,
    type: 'gallery',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-2.webp',
    images: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-1.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-2.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-4.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-5.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-6.webp',
    ],
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/90.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/91.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 101,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-12.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-12.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/92.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/70.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/71.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a>',
      },
    ],
  },
  {
    id: 102,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/72.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/73.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/women/74.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@hedoifn',
        userImg: 'https://randomuser.me/api/portraits/men/75.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 103,
    type: 'video',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-6.webp',
    video: {
      thumbnail:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-6.webp',
      link: 'https://player.vimeo.com/video/359281775?color=d4d4d4&title=0&byline=0&portrait=0&badge=0',
    },
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/76.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/77.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/78.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 104,
    type: 'gallery',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    images: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-5.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    ],
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/79.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/80.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/81.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 105,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
    commentData: [
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/81.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/men/82.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
    ],
  },
  {
    id: 106,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-7.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-7.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/82.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/men/83.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 107,
    type: 'video',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
    video: {
      thumbnail:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
      link: 'https://player.vimeo.com/video/359281775?color=d4d4d4&title=0&byline=0&portrait=0&badge=0',
    },
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/84.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/85.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/86.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/87.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 108,
    type: 'gallery',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-7.webp',
    images: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-1.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-7.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-10.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-11.webp',
    ],
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/88.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/89.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/90.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
    ],
  },
  {
    id: 109,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/91.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/92.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/93.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 110,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-10.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-10.webp',
    commentData: [
      {
        user: '@hedoifn',
        userImg: 'https://randomuser.me/api/portraits/women/94.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/95.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 111,
    type: 'video',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-12.webp',
    video: {
      thumbnail:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-12.webp',
      link: 'https://player.vimeo.com/video/359281775?color=d4d4d4&title=0&byline=0&portrait=0&badge=0',
    },
    commentData: [
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/96.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
    ],
  },
  {
    id: 112,
    type: 'gallery',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-4.webp',
    images: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-1.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-2.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-4.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-5.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-6.webp',
    ],
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/90.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/91.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 113,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-2.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-2.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/92.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/70.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/71.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a>',
      },
    ],
  },
  {
    id: 114,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/72.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/73.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/women/74.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@hedoifn',
        userImg: 'https://randomuser.me/api/portraits/men/75.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 115,
    type: 'video',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-6.webp',
    video: {
      thumbnail:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-6.webp',
      link: 'https://player.vimeo.com/video/359281775?color=d4d4d4&title=0&byline=0&portrait=0&badge=0',
    },
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/76.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/77.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/78.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 116,
    type: 'gallery',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-5.webp',
    images: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-5.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    ],
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/79.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/80.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/81.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 117,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-3.webp',
    commentData: [
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/81.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/men/82.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
    ],
  },
  {
    id: 118,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-7.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-7.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/82.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/men/83.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 119,
    type: 'video',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
    video: {
      thumbnail:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
      link: 'https://player.vimeo.com/video/359281775?color=d4d4d4&title=0&byline=0&portrait=0&badge=0',
    },
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/84.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/men/85.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/86.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/87.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 120,
    type: 'gallery',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-1.webp',
    images: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-1.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-7.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-8.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-10.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-11.webp',
    ],
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/men/88.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/89.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/90.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
    ],
  },
  {
    id: 121,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-9.webp',
    commentData: [
      {
        user: '@abcrefo',
        userImg: 'https://randomuser.me/api/portraits/women/91.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
      {
        user: '@herboif',
        userImg: 'https://randomuser.me/api/portraits/women/92.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@bobnah',
        userImg: 'https://randomuser.me/api/portraits/men/93.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 122,
    type: 'image',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-10.webp',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-10.webp',
    commentData: [
      {
        user: '@hedoifn',
        userImg: 'https://randomuser.me/api/portraits/women/94.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/95.jpg',
        userComment: 'Excellent work !!! Looks very clean and appealing 👏',
      },
    ],
  },
  {
    id: 123,
    type: 'video',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-12.webp',
    video: {
      thumbnail:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/profile/img-12.webp',
      link: 'https://player.vimeo.com/video/359281775?color=d4d4d4&title=0&byline=0&portrait=0&badge=0',
    },
    commentData: [
      {
        user: '@jackchan',
        userImg: 'https://randomuser.me/api/portraits/women/96.jpg',
        userComment:
          'Hi 👋🏻😊<br /> These are my personal favorites of my last year\'s render challenge. And maybe that\'s also a reason to try this new instagram feature... 😜<br /> <a  href="#">#lekoarts</a> <a  href="#">#arsaurea</a> <a  href="#">#photoshop</a> <a  href="#">#cinema4d</a> <a  href="#">#c4d</a> <a  href="#">#graphicdesign</a> <a  href="#">#artwork</a> <a  href="#">#digitalart</a> <a  href="#">#artoftheday</a> <a  href="#">#abstract</a>',
      },
    ],
  },
];

export const followersData = [
  {
    id: 1,
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    name: 'Thomas Stock',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 2,
    avatar: 'https://randomuser.me/api/portraits/men/97.jpg',
    name: 'Veeti Seppanen',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 3,
    avatar: 'https://randomuser.me/api/portraits/women/26.jpg',
    name: 'Bonnie Riley',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 4,
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    name: 'Steve T. Scaife',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 5,
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'Leo Gill',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 6,
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'June Cha',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 7,
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
    name: 'Renee Sims',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 8,
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    name: 'Jonathan Cha',
    buttonText: ['following', 'Follow'],
  },
  {
    id: 9,
    avatar: 'https://randomuser.me/api/portraits/men/97.jpg',
    name: 'Veeti Seppanen',
    buttonText: ['following', 'Follow'],
  },
];

export const followingData = [
  {
    id: 1,
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    name: 'Thomas Stock',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 2,
    avatar: 'https://randomuser.me/api/portraits/men/97.jpg',
    name: 'Veeti Seppanen',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 3,
    avatar: 'https://randomuser.me/api/portraits/women/26.jpg',
    name: 'Bonnie Riley',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 4,
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    name: 'Steve T. Scaife',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 5,
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'Leo Gill',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 6,
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'June Cha',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 7,
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
    name: 'Renee Sims',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 8,
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    name: 'Jonathan Cha',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 9,
    avatar: 'https://randomuser.me/api/portraits/men/97.jpg',
    name: 'Veeti Seppanen',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 10,
    avatar: 'https://randomuser.me/api/portraits/women/26.jpg',
    name: 'Bonnie Riley',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 11,
    avatar: 'https://randomuser.me/api/portraits/men/43.jpg',
    name: 'Steve T. Scaife',
    buttonText: ['follow', 'unfollow'],
  },
  {
    id: 12,
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'Leo Gill',
    buttonText: ['follow', 'unfollow'],
  },
];
